export default {"src":"/_next/static/media/Bitcool.fb670558.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};